module.exports = __webpack_public_path__ + "img/zx11.cbe9d492.png";